<div class="aside-menu-wrap slide-in-right" >
    <div class="navbar navbar-expand-lg navbar-dark bg-primary navbar-main d-block">
      <div class="container justify-content-center align-items-start relative-md">
        <a class="navbar-brand mx-auto position-absolute">
          <h1>
            <span>{{ 'MENU' | translate }}</span>
          </h1>
        </a>
        <div
          class="collapse navbar-collapse justify-content-end navbar-desktop"
        ></div>
        <div class="ms-auto btn-group" dropdown>
          <button
            class="btn-nav-menu"
            type="button"
            (click)="onCloseMenu($event)"
          >
            <fa-icon [icon]="['far', 'times']"></fa-icon>
            <span class="sr-only">{{ 'MENU' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  
    <div class="aside-menu">
      <app-loading-spinner *ngIf="isLoading" [inline]="1"></app-loading-spinner>
      <div class="container" *ngIf="userData">
        <form class="search-form standard-form mt-3" name="searchForm">
          <div class="form-group">
            <label for="q" class="sr-only">{{ 'SEARCH' | translate }}</label>
    
            <input
              type="text"
              class="form-control"
              placeholder="{{ 'SEARCH' | translate }}"
              name="q"
              id="q"
              #q="ngModel"
              ngModel
              (keyup.enter)="onSearch(q)"
            />
            <button
              (click)="onSearch(q)"
              class="btn-transparent btn btn-primary-outline"
            >
              <span class="icon-wrap"
                ><fa-icon [icon]="['far', 'search']"></fa-icon
                ><span class="sr-only">Search</span></span
              >
            </button>
          </div>
        </form>
        
        <ul class="task-list mt-3 task-list-aside-user">
          <li>
            <span class="flex-wrap">
              <img
                src="{{ avatarBase + userData?.avatar }}"
                alt="user avatar"
                class="avatar rounded"
                width="40"
                height="40"
                *ngIf="userData?.avatar"
              />
              <span class="num" *ngIf="!userData?.avatar">
                <span class="icon-wrap">
                  <fa-icon [icon]="['fal', 'user']"></fa-icon>
                </span>
              </span>
              <a class="task" [routerLink]="['/more', 'about']">
                <span class="title"
                  >{{ userData?.first_name + " " + userData?.last_name }}
                </span>
              </a></span
            >
            <ul class="nav flex-column aside-sub">
              <li class="nav-item">
                <a
                  class="nav-link"
                  [routerLink]="['/update-details']"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <span class="icon-wrap">
                    <fa-icon [icon]="['far', 'arrow-circle-right']"></fa-icon>
                  </span>
                  {{ 'UPDATE DETAILS'  | translate }}
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  [routerLink]="['/upload-avatar']"
                  [queryParams]="{ custom: '1' }"
                  routerLinkActive="active"
                >
                  <span class="icon-wrap">
                    <fa-icon [icon]="['far', 'arrow-circle-right']"></fa-icon>
                  </span>
                  {{ 'UPLOAD AVATAR'  | translate }}
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  [routerLink]="['/change-password']"
                  routerLinkActive="active"
                >
                  <span class="icon-wrap">
                    <fa-icon [icon]="['far', 'arrow-circle-right']"></fa-icon>
                  </span>
                  {{ 'CHANGE PASSWORD'  | translate }}
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [routerLink]="['']" (click)="onLogout()">
                  <span class="icon-wrap">
                    <fa-icon [icon]="['far', 'arrow-circle-right']"></fa-icon>
                  </span>
                  {{ 'LOGOUT'  | translate }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <hr />
        <ul class="task-list mt-3">
          <li>
            <span class="flex-wrap">
              <span class="num">
                <span class="icon-wrap">
                  <fa-icon
                    [icon]="['far', 'mobile']"
                    [fixedWidth]="true"
                  ></fa-icon>
                </span>
              </span>
              <a class="task" [routerLink]="['/more', 'app']">
                <span class="title">{{ 'INSTALL WEB APP'  | translate | titlecase }}</span>
                <span class="status">
                  <span class="icon-wrap">
                    <fa-icon [icon]="['far', 'arrow-alt-right']"></fa-icon>
                  </span>
                </span> </a
            ></span>
          </li>
          <li>
            <span class="flex-wrap">
              <span class="num">
                <span class="icon-wrap">
                  <fa-icon
                    [icon]="['far', 'info-circle']"
                    [fixedWidth]="true"
                  ></fa-icon>
                </span>
              </span>
              <a class="task" [routerLink]="['/more', 'about']">
                <span class="title">{{ 'ABOUT'  | translate | titlecase }}</span>
                <span class="status">
                  <span class="icon-wrap">
                    <fa-icon [icon]="['far', 'arrow-alt-right']"></fa-icon>
                  </span>
                </span> </a
            ></span>
          </li>
          <li>
            <span class="flex-wrap">
              <span class="num">
                <span class="icon-wrap">
                  <fa-icon
                    [icon]="['far', 'balance-scale']"
                    [fixedWidth]="true"
                  ></fa-icon>
                </span>
              </span>
              <a class="task" [routerLink]="['/more', 'terms']">
                <span class="title">{{ 'TERMS AND CONDITIONS'  | translate }}</span>
                <span class="status">
                  <span class="icon-wrap">
                    <fa-icon [icon]="['far', 'arrow-alt-right']"></fa-icon>
                  </span>
                </span> </a
            ></span>
          </li>
          <li>
            <span class="flex-wrap">
              <span class="num">
                <span class="icon-wrap">
                  <fa-icon
                    [icon]="['far', 'fingerprint']"
                    [fixedWidth]="true"
                  ></fa-icon>
                </span>
              </span>
              <a class="task" [routerLink]="['/more', 'privacy']">
                <span class="title">{{ 'PRIVACY POLICY'  | translate }}</span>
                <span class="status">
                  <span class="icon-wrap">
                    <fa-icon [icon]="['far', 'arrow-alt-right']"></fa-icon>
                  </span>
                </span> </a
            ></span>
          </li>
        </ul>
      </div>
    </div>
  </div>
  